const initialQuery = `
# Welcome to Altair GraphQL Client.
# You can send your request using CmdOrCtrl + Enter.

# Enter your graphQL query here.
`.trimStart();

export { initialQuery };
